import { parseJson } from "@common/TypesHelper";
import {RealtimeMessageModel} from "@api/repositories/reatime-repository/types";

export const getMessageObjectIfSuccess = (message: string | object) => {
    try {
        const messageObject: RealtimeMessageModel = parseJson(message);

        return messageObject.error ? null : messageObject;
    }
    catch (e) {
        console.error(e)
        return null;
    }
}
